Vue.component('menu-header', {
    delimiters: ['[[', ']]'],
    template: `
        <div>
            <div class="mainbar-wrap">
                <div class="megamenu-hover-bg"></div><!-- /.megamenu-hover-bg -->
                <div class="container-fluid mainbar-container">
                    <div class="mainbar">
                        <div class="row mainbar-row align-items-lg-stretch px-4">
                            
                            <div class="col-auto">
                                <div class="navbar-header">
                                    <a class="navbar-brand" href="index.html" rel="home">
                                        <span class="navbar-brand-inner">
                                            <img class="logo-dark" src="./assets/img/spartaquant/icon-color.png" width="60px" alt="SpartaQuant icon">
                                            <img class="logo-sticky" src="./assets/img/spartaquant/icon-color.png" width="60px" alt="SpartaQuant icon">
                                            <img class="mobile-logo-default" src="./assets/img/spartaquant/icon-color.png" width="60px" alt="SpartaQuant icon">
                                            <img class="logo-default" src="./assets/img/spartaquant/icon-color.png" width="60px" alt="SpartaQuant icon">
                                        </span>
                                    </a>
                                    <button type="button" class="navbar-toggle collapsed nav-trigger style-mobile" data-toggle="collapse" data-target="#main-header-collapse" aria-expanded="false" data-changeclassnames='{ "html": "mobile-nav-activated overflow-hidden" }'>
                                        <span class="sr-only">Toggle navigation</span>
                                        <span class="bars">
                                            <span class="bar"></span>
                                            <span class="bar"></span>
                                            <span class="bar"></span>
                                        </span>
                                    </button>
                                </div><!-- /.navbar-header -->
                            </div><!-- /.col -->
                            
                            <div class="col">
                                
                                <div class="collapse navbar-collapse" id="main-header-collapse">
                                    
                                    <ul id="primary-nav" class="main-nav nav align-items-lg-stretch justify-content-lg-start" data-submenu-options='{ "toggleType":"fade", "handler":"mouse-in-out" }' data-localscroll="true">
    
                                        <li>
                                            <a href="#how" id="menuHow">
                                                <span class="link-icon"></span>
                                                <span class="link-txt">
                                                    <span class="link-ext"></span>
                                                    <span class="txt">
                                                        How it works
                                                        <span class="submenu-expander">
                                                            <i class="fa fa-angle-down"></i>
                                                        </span>
                                                    </span>
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#features" id="menuFeatures">
                                                <span class="link-icon"></span>
                                                <span class="link-txt">
                                                    <span class="link-ext"></span>
                                                    <span class="txt">
                                                        Features
                                                        <span class="submenu-expander">
                                                            <i class="fa fa-angle-down"></i>
                                                        </span>
                                                    </span>
                                                </span>
                                            </a>
                                        </li>
                                        <!-- <li>
                                            <a href="#works">
                                                <span class="link-icon"></span>
                                                <span class="link-txt">
                                                    <span class="link-ext"></span>
                                                    <span class="txt">
                                                        Last releases
                                                        <span class="submenu-expander">
                                                            <i class="fa fa-angle-down"></i>
                                                        </span>
                                                    </span>
                                                </span>
                                            </a>
                                        </li> -->
                                        <li>
                                            <a href="#pricing" id="menuPricing">
                                                <span class="link-icon"></span>
                                                <span class="link-txt">
                                                    <span class="link-ext"></span>
                                                    <span class="txt">
                                                        Pricing
                                                        <span class="submenu-expander">
                                                            <i class="fa fa-angle-down"></i>
                                                        </span>
                                                    </span>
                                                </span>
                                            </a>
                                        </li>

                                        <li>
                                            <a href="https://spartaquant.pro/publicAPI">
                                                <span class="link-icon"></span>
                                                <span class="link-txt">
                                                    <span class="link-ext"></span>
                                                    <span class="txt">
                                                        API
                                                        <span class="submenu-expander">
                                                            <i class="fa fa-angle-down"></i>
                                                        </span>
                                                    </span>
                                                </span>
                                            </a>
                                        </li>

                                        <li>
                                            <a href="/terms">
                                                <span class="link-icon"></span>
                                                <span class="link-txt">
                                                    <span class="link-ext"></span>
                                                    <span class="txt">
                                                        Terms
                                                        <span class="submenu-expander">
                                                            <i class="fa fa-angle-down"></i>
                                                        </span>
                                                    </span>
                                                </span>
                                            </a>
                                        </li>
                                    
                                    </ul><!-- /#primary-nav  -->
                                
                                </div><!-- /#main-header-collapse -->
                                
                            </div><!-- /.col -->
                        
                            <div class="col text-right">

                                <!-- <div class="header-module">
                                    <p>CALL US 24/7: <span style="color: var(--color-primary);">+0093 1468 09 03</span></p>
                                </div>

                                <div class="header-module">
                                    <a href="#" class="btn btn-default text-uppercase btn-sm circle btn-bordered border-thin px-2">
                                        <span>
                                            <span class="btn-txt">Download now</span>
                                        </span>
                                    </a>
                                </div> -->
                                
                            </div><!-- /.col -->
                        
                        </div><!-- /.mainbar-row -->
                    </div><!-- /.mainbar -->
                </div><!-- /.mainbar-container -->
            </div><!-- /.mainbar-wrap -->
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {
            menuType: 1,
            iniUrl: '',
        }
    },
    mounted(){
        this.iniUrl = document.location.href;
        this.anchorUrl();
    },
    methods: {
        anchorUrl: function(){
            var _this = this;
            $(document).ready(function(){
                $("#menuHow").click(function(){
                    var url = _this.iniUrl+"#how";
                    document.location = url;
                });

                $("#menuFeatures").click(function() {
                    var url = _this.iniUrl+"#features";
                    document.location = url;
                });

                $("#menuPricing").click(function() {
                    var url = _this.iniUrl+"#pricing";
                    document.location = url;
                });
            });
        },
        test: function(){

        }
    },
});